// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vG9y","questions":"styles_questions__12O1T","footer":"styles_footer__3YdyG"};